var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholderDp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#16CFB0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9998 19.8831C42.6674 19.8831 45.2259 20.9428 47.1122 22.8291C48.9985 24.7154 50.0583 27.2739 50.0583 29.9415C50.0583 32.6092 48.9985 35.1676 47.1122 37.054C45.2259 38.9403 42.6674 40 39.9998 40C37.3321 40 34.7737 38.9403 32.8874 37.054C31.001 35.1676 29.9413 32.6092 29.9413 29.9415C29.9413 27.2739 31.001 24.7154 32.8874 22.8291C34.7737 20.9428 37.3321 19.8831 39.9998 19.8831ZM39.9998 45.0293C51.1144 45.0293 60.1167 49.5304 60.1167 55.0877V60.117H19.8828V55.0877C19.8828 49.5304 28.8852 45.0293 39.9998 45.0293Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderDp);
export default __webpack_public_path__ + "static/media/placeholder-dp.f6c2926f4c365ea9530fe32a7f07ce47.svg";
export { ForwardRef as ReactComponent };